import { useEffect, useState } from 'react';

const useDirection = () => {
  const [direction, setDirection] = useState(false);

  useEffect(() => {
    setDirection(document?.dir === 'rtl');
  }, []);

  return direction;
};

export default useDirection;
